module.exports = __webpack_public_path__ + "dm.eecccf82.svg";